import React from "react";

export function ScoreBar({ label, score, max = 10, testId, highlight = false }) {
  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  const isPerfect = score >= max;
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      <div className="flex items-baseline justify-between">
        <span className={`text-sm font-medium ${highlight ? "text-[#E8B14A]" : "text-zinc-300"}`}>
          {label}
          {highlight && (
            <span className="ml-2 inline-block align-middle px-2 py-0.5 text-[9px] font-mono-accent uppercase tracking-[0.25em] bg-[#E8B14A] text-black rounded-[2px]">
              Jury-Highlight
            </span>
          )}
        </span>
        <span className={`font-mono-accent text-xs ${isPerfect ? "text-[#E8B14A] font-bold" : "text-[#E8B14A]"}`}>
          {score.toFixed(1)}
          <span className="text-zinc-500"> / {max}</span>
        </span>
      </div>
      <div
        className={`score-bar ${isPerfect ? "ring-1 ring-[#E8B14A]/50" : ""}`}
        aria-valuenow={score}
        aria-valuemax={max}
        role="progressbar"
      >
        <span style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default ScoreBar;
